import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { FaFileExport } from "react-icons/fa";
import { Audit } from "../interFaces/interfaces";
import EncryptionUtils from "../main/encryptionUtils";
const NCTracker: React.FC = () => {
  const [data, setData] = useState<Audit[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const navigate = useNavigate();
  const [fields, setFields] = useState<any>({});
  const clientId = localStorage.getItem("clientId");
  const columns = [{ key: "campaignName", label: "Campaign Name" }, { key: "projectName", label: "Project Name" }, { key: "auditStatus", label: "Audit Status" }];
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["NCTracker"]) {
      setFields(permissions.tabs["NCTracker"].fields);
    } else {
      console.log("No permissions found for 'NCTracker' tab");
    }
  }, []);
  const fetchAllAudits = async () => {
    try {
      const response = await apiCall("get", `/api/audit?page=0&size=${totalElements}&clientId=${clientId}`);
      return response.content || [];
    } catch (error) {
      console.error("Failed to export audits. Please try again later.");
      return [];
    }
  };
  useEffect(() => {
    const fetchAudits = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", `/api/audit?clientId=${clientId}&page=${currentPage - 1}&size=${itemsPerPage}`);
        setData(response.content || []);
        setTotalPages(response.totalPages || 0);
        setTotalElements(response.totalElements || 0);
      } catch (error) {
        console.error("Error fetching audits:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAudits();
  }, [clientId, currentPage, itemsPerPage]);
  const handleAuditClick = (audit: Audit) => {
    navigate(`/nctrackerdetails/${audit.campaignName}`, {
      state: { auditId: audit.auditId, campaignId: audit.campaignId, projectId: audit.projectId, },
    });
  };
  const handleRowExport = async (audit: Audit) => {
    try {
      const response = await apiCall("get", `/api/nctracker/campaign/${audit.campaignId}/project/${audit.projectId}/audit/${audit.auditId}/questions`, {}, { page: 0, size: 2147483647 })
      if (!response || !response.content) {
        console.warn("No data available for export");
        return;
      }
      const questions = response.content || [];
      const controlFields = [{ key: "pims", label: "PIMS" }, { key: "isms", label: "ISMS" }, { key: "bcms", label: "BCMS" }, { key: "cmmi", label: "CMMI" }, { key: "soc1", label: "SOC1" }, { key: "soc2", label: "SOC2" }, { key: "qms", label: "QMS" }, { key: "aims", label: "AIMS" }, { key: "erm", label: "ERM" }, { key: "itsm", label: "ITSM" }, { key: "ers", label: "ERS" }, { key: "ohs", label: "OHS" },];
      const availableControls = controlFields.filter((cf) => questions.some((q: any) => q[cf.key]));
      const hasControlFields = availableControls.length > 0;
      const showPracticeAreaColumn = !hasControlFields;
      const mappedData = questions.map((item: any) => {
        const baseData: any = { "Question": item.questionText || "", "Type of Findings": item.typeOfFindings || "", "Findings": item.findings || "", "Corrective Action": item.correctiveAction || "", "Correction": item.correction || "", "RCA": item.rca || "", "Action Taken": item.actionTaken || "", "Verified By QC": item.verifiedByQC ? "Yes" : "No", "QC Comments": item.qcComments || "", "NC Status": item.ncTrackerStatus || "" };
        if (showPracticeAreaColumn) {
          baseData["Control/Practice Area"] = item.practiceArea || "";
        }
        availableControls.forEach((cf) => {
          baseData[cf.label] = item[cf.key] || "";
        });
        return baseData;
      });
      if (mappedData.length === 0) {
        console.warn("No data available for export");
        return;
      }
      const headers = Object.keys(mappedData[0]);
      const csvHeaders = headers.join(",");
      const csvRows = mappedData
        .map((obj: any) =>
          headers
            .map((header) => `"${String(obj[header] || "").replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");
      const csvContent = csvHeaders + "\n" + csvRows;
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;", });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `NC_Tracker_${audit.auditId}_${new Date()
        .toISOString()
        .split("T")[0]}.csv`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      console.error("Failed to export audit:", error);
    }
  };
  const handleAuditCellClick = (audit: any) => {
    if (!fields.view) return;
    handleAuditClick(audit);
  };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>NC Tracker</h2>
        <div className="table-title-actions">
          <ExportButton data={data} columns={columns} fetchAllData={fetchAllAudits} fileName="audits" />
        </div>
      </div>
      <div className="table-container">
        <div className="table-inner-container">
          <table className="main-table">
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((audit) => (
                  <tr key={audit.auditId}>
                    <td onClick={() => handleAuditCellClick(audit)} className="clickable">{audit.campaignName}</td>
                    <td>{audit.projectName || "N/A"}</td>
                    <td>{audit.auditStatus || "N/A"}</td>
                    <td className="action-cell">
                      <FaFileExport className="action-button" onClick={() => handleRowExport(audit)} title="Export this Audit" />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length + 1} className="no-data">No audits found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
    </div>
  );
};
export default NCTracker;